import store from '../../store/store';
import setClauseValue from '../setClauseValue';
import { action } from 'satcheljs/lib/legacy';
import datapoints from '../../datapoints';
import InboxRuleActionSource from '../../store/schema/InboxRuleActionSource';
/**
 * Adds a phrase to a 'contains words' clause value
 * @param clauseId the id of the clause to add the phrase to
 * @param phraseToAdd the phrase to add the the clause value
 * @param actionSource the source of the action (onBlur, keyboard)
 */
export default action('addPhraseToClause', datapoints.addPhraseToClauseDatapoint)(
    function addPhraseToClause(
        clauseId: string,
        phraseToAdd: string,
        actionSource: InboxRuleActionSource
    ) {
        let existingPhrases = store.inboxRulesEditState.clauseMap.get(clauseId)
            .clauseValue as string[];

        if (!existingPhrases) {
            existingPhrases = [];
        }
        // only add unique, non-empty phrases
        if (existingPhrases.indexOf(phraseToAdd) == -1) {
            existingPhrases.push(phraseToAdd);
            setClauseValue(existingPhrases, clauseId);
            // clear the input field if the phrase was added
            store.inboxRulesEditState.includesWordsInputTextMap.set(clauseId, '');
        }
    }
);
